import React, { useState } from 'react';
import { Field, ErrorMessage } from 'formik';
import TextError from './TextError';
import moment from 'moment';

function Input(props) {
  const { label, name, formik, type = 'text', readOnly = false, ...rest } = props;
  const [focused, setFocused] = useState(false);

  const isError = formik.touched[name] && formik.errors[name];
  const value = formik.values[name] || '';
  const isActive = focused || value;

  // Fix date formatting
  // const formattedValue =
  //   type === 'date' && value ? new Date(value).toISOString().split('T')[0] : value;
  // const formattedValue =
  //   type === 'date' && value ? new Date(value)
  //     .toLocaleDateString("en-GB", {
  //       day: "2-digit",
  //       month: "short",
  //       year: "numeric",
  //       timeZone: "UTC"
  //     })
  //     .replace(/ /g, "-")
  //     .toUpperCase() : value;
  const formattedValue =
  type === 'date' && value
    ? moment(value).format('DD-MMM-YYYY')
    : value;

  // Container base
  const containerBase =
    'relative input-container w-full transition-all duration-300 rounded-lg border';

  // Dynamic container styles
  let containerClasses = '';
  if (readOnly) {
    containerClasses =
      'backdrop-blur-sm bg-gray-100/50 cursor-not-allowed border-gray-200';
  } else if (isError) {
    containerClasses = 'border-red-500';
  } else if (focused) {
    containerClasses = 'border-primary shadow-md backdrop-blur-md bg-white/70';
  } else {
    containerClasses = 'border-lighter bg-white/50';
  }

  return (
    <div className="relative form-row">
      {/* Input Container */}
      <div className={`${containerBase} ${containerClasses}`}>
        {/* Input Field */}
        <Field
          id={name}
          name={name}
          type={type}
          value={formattedValue}
          readOnly={readOnly}
          onFocus={!readOnly ? () => setFocused(true) : undefined}
          onBlur={!readOnly ? () => setFocused(false) : undefined}
          className={`w-full py-3 px-4  rounded-lg outline-none transition-all duration-200
            ${
              readOnly
                ? 'text-gray-500 bg-transparent select-none'
                : focused
                ? '  text-primary bg-transparent'
                : isError
                ? 'text-red-600 bg-transparent'
                : 'text-gray-500 bg-transparent'
            }
          `}
          {...rest}
        />

        {/* Floating Label */}
        <label
          htmlFor={name}
          className={`absolute left-4 transition-all duration-300 pointer-events-none bg-light2 px-1
            ${
              isActive
                ? `top-[-12px] text-[13px] ${
                    isError
                      ? 'text-red-500'
                      : focused
                      ? 'text-primary'
                      : 'text-gray-600'
                  }`
                : 'top-[-12px] text-gray-400'
            }
          `}
        >
          {label}
        </label>
      </div>

      {/* Error Message */}
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default Input;
